
import { Link } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { AccessibilityButton } from "@/components/AccessibilityButton";

const Sitemap = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <div className="container mx-auto px-6 py-16">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold font-primary text-gray-800 mb-8">
            Mapa do Site
          </h1>
          
          <div className="grid md:grid-cols-2 gap-8">
            {/* Páginas Principais */}
            <div className="bg-green-50 p-6 rounded-lg">
              <h2 className="text-2xl font-semibold font-secondary text-green-700 mb-4">
                Páginas Principais
              </h2>
              <ul className="space-y-3">
                <li>
                  <Link 
                    to="/inicio" 
                    className="text-green-600 hover:text-green-800 font-text transition-colors"
                  >
                    Início
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/sobre" 
                    className="text-green-600 hover:text-green-800 font-text transition-colors"
                  >
                    Nossa História
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/servicos" 
                    className="text-green-600 hover:text-green-800 font-text transition-colors"
                  >
                    Serviços
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/blog" 
                    className="text-green-600 hover:text-green-800 font-text transition-colors"
                  >
                    Blog
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/contato" 
                    className="text-green-600 hover:text-green-800 font-text transition-colors"
                  >
                    Contato
                  </Link>
                </li>
              </ul>
            </div>

            {/* Páginas Especializadas */}
            <div className="bg-gray-50 p-6 rounded-lg">
              <h2 className="text-2xl font-semibold font-secondary text-gray-700 mb-4">
                Páginas Especializadas
              </h2>
              <ul className="space-y-3">
                <li>
                  <Link 
                    to="/consultorios" 
                    className="text-gray-600 hover:text-gray-800 font-text transition-colors"
                  >
                    Consultórios
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/avaliacoes" 
                    className="text-gray-600 hover:text-gray-800 font-text transition-colors"
                  >
                    Avaliação de Caso
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/sitemap" 
                    className="text-gray-600 hover:text-gray-800 font-text transition-colors"
                  >
                    Mapa do Site
                  </Link>
                </li>
              </ul>
            </div>

            {/* Seções da Página Inicial */}
            <div className="bg-blue-50 p-6 rounded-lg md:col-span-2">
              <h2 className="text-2xl font-semibold font-secondary text-blue-700 mb-4">
                Seções da Página Inicial
              </h2>
              <div className="grid md:grid-cols-3 gap-4">
                <ul className="space-y-2">
                  <li className="text-blue-600 font-text">Hero Section</li>
                  <li className="text-blue-600 font-text">História da Nutricionista</li>
                  <li className="text-blue-600 font-text">Jornada do Paciente</li>
                </ul>
                <ul className="space-y-2">
                  <li className="text-blue-600 font-text">Abordagens</li>
                  <li className="text-blue-600 font-text">Serviços</li>
                  <li className="text-blue-600 font-text">Blog</li>
                </ul>
                <ul className="space-y-2">
                  <li className="text-blue-600 font-text">Instagram</li>
                  <li className="text-blue-600 font-text">FAQ</li>
                  <li className="text-blue-600 font-text">Depoimentos</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Informações Adicionais */}
          <div className="mt-12 bg-yellow-50 p-6 rounded-lg">
            <h2 className="text-2xl font-semibold font-secondary text-yellow-700 mb-4">
              Informações do Site
            </h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <h3 className="font-semibold text-yellow-600 mb-2">Contato</h3>
                <p className="text-gray-600 font-text">WhatsApp: (11) 99887-4081</p>
                <p className="text-gray-600 font-text">CRN: 3/63492</p>
                <p className="text-gray-600 font-text">CNPJ: 55.373.902/0001-65</p>
              </div>
              <div>
                <h3 className="font-semibold text-yellow-600 mb-2">Desenvolvimento</h3>
                <p className="text-gray-600 font-text">
                  Desenvolvido por{" "}
                  <a 
                    href="https://www.finalogica.com.br" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-yellow-700 hover:text-yellow-800 transition-colors"
                  >
                    Finalógica Soluções
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <FloatingWhatsApp />
      <AccessibilityButton />
    </div>
  );
};

export default Sitemap;
